export class Icp {
    number: string
    url: string
    suffix: string
    constructor(number: string = null, url: string = null, suffix: string = '') {
        this.number = number;
        this.url = url;
        this.suffix = suffix;
    }
}